<template>
  <section>
    <Title v-if="title.PhotoPay" :title-name="pageTitle" :title-link="title.PhotoPay.titleLink" />
    <div v-if="pax && !pax.is_expired_p2c" class="photo-pay-container">
      <div v-if="!service || !service.price_per_person">
        <div class="container">
          <div v-if="lang[2]" class="mt-3">
            <p>{{ lang[2].SFS_LANG_ROW_9 }}</p>
          </div>
        </div>
      </div>
      <div v-else-if="lang && lang.refreshment_photo_claim_new" id="photo-pay" class="photo-pay container pt-4">
        <div>
          <div class="title-voucher refreshment-voucher mb-3">
            <ItemOfVouchers
              icon="refreshment-voucher"
              color="#54ceae"
              :label="lang['refreshment_photo_claim_new'].SFS_LANG_ROW_1"
              border
            />
          </div>
          <div class="photo2claim">
            <PhotoPayStep
              v-if="step == 1"
              :secret="secret"
              :refreshment-info="RefreshmentInfoPax"
              :refreshment-price="RefreshmentPrice"
              :is-name-null="isNameNull"
              @nextStep="nextStep"
              @updateIsNameNull="updateIsNameNull"
            />
          </div>
        </div>
        <PhotoPayInfo
          v-if="step == 2"
          :secret="secret"
          :refreshment-info="RefreshmentInfoPax"
          :refreshment-price="RefreshmentPrice"
        />
      </div>
    </div>
    <div v-else-if="pax && pax.is_expired_p2c">
      <div class="container">
        <div v-if="lang.expire_link" class="mt-3">
          <p>{{ lang.expire_link.SFS_LANG_ROW_4 }}</p>
        </div>
      </div>
    </div>
    <b-alert
      v-model="showAlertTop"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000; border-radius: 1rem !important; border: 1px solid #ffa5a5; color: #444"
      variant="danger"
      dismissible
    >
      <div v-for="(error, index) in messagesError" :key="index">
        <div>{{ error }}</div>
      </div>
    </b-alert>
  </section>
</template>
<script>
import '@/assets/scss/modules/PhotoPay.scss'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'
import Title from '@/components/Title/index'
import PhotoPayStep from './PhotoPayStep'
import PhotoPayInfo from './PhotoPayInfo'
import { mapGetters } from 'vuex'

export default {
  components: { ItemOfVouchers, Title, PhotoPayStep, PhotoPayInfo },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      step: 1,
      RefreshmentInfoPax: {},
      service: {},
      isNameNull: false,
      messagesError: [],
      showAlertTop: false
    }
  },
  computed: {
    ...mapGetters({
      RefreshmentInfo: 'Refreshment/RefreshmentInfo',
      RefreshmentPrice: 'Refreshment/RefreshmentPrice',
      Services: 'Home/Services',
      dataInfoBankPax: 'Refreshment/dataInfoBankPax'
    }),
    pageTitle() {
      const { lang } = this
      return lang && lang.hotel_mobile_new && this.lang.hotel_mobile_new.SFS_LANG_ROW_28
        ? lang.hotel_mobile_new.SFS_LANG_ROW_28
        : 'Home'
    }
  },
  watch: {
    RefreshmentInfo: {
      handler() {
        this.checkStep()
      },
      deep: true
    },
    Services: {
      handler() {
        this.checkStep()
      },
      deep: true
    },
    airline: function () {
      if (this.airline.meal_enabled != '2') {
        let secret = this.$route.query.secret
        this.$router.push({ path: '/home', query: { secret: secret } })
      }
    },
    showAlertTop() {
      if (this.showAlertTop) {
        setTimeout(() => {
          this.showAlertTop = false
        }, 5000)
      }
    }
  },
  created() {
    if (!this.$route.query.refreshmentId) {
      this.$router.push({ path: '/home', query: { secret: this.$route.query.secret } })
      return
    }
    this.$store.dispatch('Refreshment/getInfoRef', this.$route.query.refreshmentId)
    this.$store
      .dispatch('Refreshment/getPriceRef', this.$route.query.refreshmentId)
      .then((response) => {
        if (!response.length) {
          this.$router.push({ path: '/home', query: { secret: this.$route.query.secret } })
        }
      })
      .catch((e) => {
        this.$router.push({ path: '/home', query: { secret: this.$route.query.secret } })
      })
    this.$store.dispatch('Home/getServices')
  },
  mounted() {
    this.checkStep()
  },
  beforeDestroy() {
    this.$store.dispatch('Refreshment/resetRefreshmentInfo')
  },
  methods: {
    updateIsNameNull(value) {
      this.isNameNull = value
      if (this.isNameNull) {
        this.showAlertTop = true
        this.messagesError.push('Enter an account holder name')
      } else {
        this.showAlertTop = false
      }
    },
    nextStep(data) {
      this.step = data
    },
    checkStep() {
      if (this.Services.length == 0) {
        this.$store.dispatch('Home/getServices')
      }
      this.service = _.find(this.Services, { service_id: 2 })
      if (!this.service || _.isEmpty(this.service.price_per_person)) {
        return false
      }
      if (this.RefreshmentInfo && this.RefreshmentInfo.bank_info) {
        this.RefreshmentInfoPax = this.RefreshmentInfo
        if (this.RefreshmentInfo.bank_info && !_.isEmpty(this.RefreshmentInfo.bank_info.transfer_bank_info)) {
          this.step = 2
        } else {
          this.step = 1
        }
      } else {
        this.$store.dispatch('Refreshment/getInfoRef', this.$route.query.refreshmentId)
      }
    }
  }
}
</script>
